export const convertBytesToMegabytes = (bytes: number) => {
  const result = bytes / 1000000;
  return Number(result.toFixed(2));
};

export const convertMegabytesToBytes = (megabytes: number) => {
  const result = megabytes * 1024 * 1024;
  return Number(result.toFixed(2));
};

export const convertFileToBase64 = (file?: File): Promise<null | string> => {
  const reader = new FileReader();

  return new Promise((resolve, reject) => {
    if (file) {
      reader.readAsDataURL(file);
      reader.onload = () => {
        if (reader.result && typeof reader.result === 'string') {
          resolve(reader.result.split(',')[1]);
        }
      };
      reader.onerror = () => {
        reject(new Error('Failed to read the file.'));
      };
    } else resolve(null);
  });
};

export const downloadBase64File = (base64Data: string, fileName: string) => {
  const linkSource = `data:application/octet-stream;base64,${base64Data}`;
  const downloadLink = document.createElement('a');
  downloadLink.href = linkSource;
  downloadLink.download = fileName;
  downloadLink.click();
};

export const convertToNumber = (value: any) =>
  typeof value === 'string' ? Number(value) : value;

export const getFileExtension = (filename: string) => {
  const match = /\.([^.]+)$/.exec(filename);
  if (!match) return '';
  return `.${match[1]}`;
};
